module.exports = __webpack_public_path__ + "static/media/island1.da4294f0.jpg";